import React from 'react';
import PropTypes from 'prop-types';
import {
    getInsertMark,
    getSubstituteMark,
    getOlMarksClassNames,
    getInsertMarkContent,
    getSubstituteMarkContent,
    isEndPosition,
} from '../../../../../utils/shared/marksBuilderUtils';
import './Word.scss';

const Word = ({ sentenceLength, word, marks, isItalic, wordPosition }) => {
    const isEnd = isEndPosition(wordPosition, sentenceLength);
    const {
        insertWordClasses,
        wordWrapperClasses,
        insertWordWrapperClasses,
        wordClasses,
        substituteWordClasses,
    } = getOlMarksClassNames(marks, wordPosition, isEnd, isItalic);
    const insertMark = getInsertMark(marks);
    const substituteMark = getSubstituteMark(marks);

    return (
        <>
            {insertMark && (
                <span className="word-container">
                    {getInsertMarkContent({
                        insertMark,
                        insertWordWrapperClasses,
                        insertWordClasses,
                    })}
                </span>
            )}
            <span className="word-container">
                {getSubstituteMarkContent({
                    word,
                    wordClasses,
                    substituteMark,
                    wordWrapperClasses,
                    substituteWordClasses,
                })}
            </span>
        </>
    );
};

Word.defaultProps = {
    sentenceLength: null,
    word: '',
    marks: [],
    isItalic: false,
    wordPosition: null,
};

Word.propTypes = {
    sentenceLength: PropTypes.number,
    word: PropTypes.string,
    marks: PropTypes.array,
    isItalic: PropTypes.bool,
    wordPosition: PropTypes.number,
};

export default Word;
